/*
 * Values the camp search filters can match (backend utils/search/campFilters.js)
 * — exactly what the stay form saves, so a filter option always finds stays.
 *   unitTypes      units[].unitType   (pages/accommodation/units/UnitEditor.jsx)
 *   propertyTypes  propertyType       (pages/accommodation/basic/BasicInformation.jsx)
 *   amenities      amenities.*        (pages/accommodation/amenities/AmenitiesSection.jsx)
 */
import { AMENITY_GROUPS } from '../pages/accommodation/amenities/AmenitiesSection';

const UNIT_TYPES = [
    { value: 'tent', label: 'Tent' },
    { value: 'room', label: 'Private Room' },
    { value: 'suite', label: 'Suite' },
    { value: 'dorm', label: 'Dormitory' },
    { value: 'bed', label: 'Bed in Dorm' },
    { value: 'cottage', label: 'Cottage' },
    { value: 'cabin', label: 'Cabin' },
    { value: 'treehouse', label: 'Treehouse' },
    { value: 'villa', label: 'Villa' },
    { value: 'apartment', label: 'Apartment' },
    { value: 'entire_property', label: 'Entire Property' },
    { value: 'campsite', label: 'Campsite (own tent)' },
    { value: 'other', label: 'Other' }
];

const PROPERTY_TYPES = [
    { value: 'camping', label: 'Camping' },
    { value: 'campsite', label: 'Campsite' },
    { value: 'tent', label: 'Tent Stay' },
    { value: 'resort', label: 'Resort' },
    { value: 'villa', label: 'Villa' },
    { value: 'homestay', label: 'Homestay' },
    { value: 'cottage', label: 'Cottage' },
    { value: 'cabin', label: 'Cabin' },
    { value: 'treehouse', label: 'Treehouse' },
    { value: 'farmstay', label: 'Farmstay' },
    { value: 'hostel', label: 'Hostel' },
    { value: 'guesthouse', label: 'Guesthouse' },
    { value: 'hotel', label: 'Hotel' },
    { value: 'house', label: 'House' },
    { value: 'apartment', label: 'Apartment' },
    { value: 'other', label: 'Other' }
];

// every amenity on the stay form, grouped like the form (each once)
const seen = new Set();
const AMENITIES = AMENITY_GROUPS.map((group) => ({
    group: group.title,
    options: group.items
        .filter((item) => {
            const key = item.toLowerCase();
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        })
        .map((item) => ({ value: item, label: item }))
})).filter((g) => g.options.length);

export const CAMP_FILTER_FIELDS = [
    { value: 'unitTypes', label: 'Room / tent type', groups: [{ group: '', options: UNIT_TYPES }] },
    { value: 'propertyTypes', label: 'Property type', groups: [{ group: '', options: PROPERTY_TYPES }] },
    { value: 'amenities', label: 'Amenities', groups: AMENITIES }
];

/** All options of a field, flat: [{ value, label }] */
export const campFilterOptions = (field) =>
    (CAMP_FILTER_FIELDS.find((f) => f.value === field)?.groups || []).flatMap((g) => g.options);
